import { wait } from "@entrilia/shared/utilities/promiseHelper.ts";

export const withRequestDelay =
  <R>(request: (signal?: AbortSignal) => Promise<R>, delayMs: number): ((signal?: AbortSignal) => Promise<R>) =>
  async (signal) => {
    signal?.throwIfAborted();
    await wait(delayMs);
    signal?.throwIfAborted();
    return request(signal);
  };
